interface ISportDefinition {
  defaultGender?: 'girls' | 'boys' | undefined;
  isSingleGender?: boolean;
}

const DEFAULT_SPORT_DEFINITION: ISportDefinition = {
  defaultGender: undefined,
  isSingleGender: false
};

const map = new Map<string, ISportDefinition>();
map.set('softball', { defaultGender: 'girls', isSingleGender: true });
map.set('baseball', { defaultGender: 'boys', isSingleGender: true });
map.set('flag football', { defaultGender: 'girls', isSingleGender: true });
map.set('field hockey', { defaultGender: 'girls', isSingleGender: true });
map.set('volleyball', { defaultGender: 'girls' });
map.set('basketball', { defaultGender: 'boys' });
map.set('soccer', { defaultGender: 'boys' });
map.set('football', { defaultGender: 'boys', isSingleGender: true });

const getSportDefinition = (sportName: string): ISportDefinition => ({
  ...DEFAULT_SPORT_DEFINITION,
  ...map.get(sportName.toLowerCase())
});

export default getSportDefinition;
